<ag-grid-angular
  [class.ag-xvi]="true"
  [ngClass]="_XVIGridClass"
  [gridOptions]="_gridOptions"
  [columnDefs]="columnDefs"
  [frameworkComponents]="frameworkComponents"
  [rowData]="rowData"
  (gridReady)="onGridReady($event)"
></ag-grid-angular>
